var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.965 2.035C73.0314 1.10141 71.633 0.628796 70.2502 1.10531L3.16815 24.2893C1.82435 24.7541 0.984552 26.0393 0.922052 27.2815C0.859552 28.5276 1.56267 29.8909 2.85175 30.4924L29.2038 42.7694C29.5163 42.9178 29.817 43.0897 30.11 43.2694L53.305 20.0744C54.0277 19.3517 55.1995 19.3517 55.9261 20.0744C56.6488 20.801 56.6488 21.9728 55.9261 22.6955L32.7311 45.8905C32.9147 46.1835 33.0866 46.4803 33.2311 46.7968L45.5081 73.1488C46.1097 74.4418 47.4729 75.1449 48.719 75.0785C49.9651 75.016 51.2463 74.1722 51.7112 72.8285L74.8952 5.75046C75.3718 4.36766 74.9025 2.9686 73.965 2.035Z",
    fill: "#2A3953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMenuIcon);
export default __webpack_public_path__ + "static/media/notificationMenuIcon.2412a0322cb49dfcf8cf29408a50ca27.svg";
export { ForwardRef as ReactComponent };